import { MenuItem, TextField, Tooltip } from "@material-ui/core";
import { Col, Row } from "antd";
import AvatarUserDefaultIcon from "assets/avatar_user_default.png";
import datetimeHelper from "helper/datetime-helper";
import moment from "moment";
import { useSnackbar } from "notistack";
import PopupAddNewChat from "pages/agent-chat-ticket/agent-chat-header/PopupAddNewChat";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getStatusAgent } from "redux/agent";
import {
  changeAgentChatStatusApi,
  getAgentChatStatistic,
  setAgentChatStatus,
} from "redux/ringme-ott-sdk";
import { getPercentage } from "ultis/commonFunctions";

import classes from "../AgentChatTicket.module.css";

const AgentDashboardHeader = () => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const ringmeOttSdk = useSelector((state) => state.ringmeOttSdk.ringmeOttSdk);
  const agentStatus = useSelector((state) => state.agent.status); // trạng thái của điện thoại viên
  const user = useSelector((state) => state.auth.init);

  const [loadingChangeAgentChatStatus, setLoadingChangeAgentChatStatus] =
    useState(false);

  const agentChatStatistic = useSelector(
    (state) => state.ringmeOttSdk.agentChatStatistic
  );

  const isAuthenticatedSdk = useSelector(
    (state) => state.ringmeOttSdk.isAuthenticatedSdk
  );
  const agentChatStatus = useSelector(
    (state) => state.ringmeOttSdk.agentChatStatus
  );

  const [chatReport, setChatReport] = useState();

  const handleChangeAgentChatStatus = async (e) => {
    setLoadingChangeAgentChatStatus(true);
    const newStatus = e.target.value;
    if (agentChatStatus === newStatus) return;
    try {
      if (agentChatStatus === "service") {
        const ringmeChatReport = await new Promise((resolve, reject) => {
          const params = {
            startedAt: moment().startOf("day").valueOf(),
            endedAt: moment().valueOf(),
          };
          ringmeOttSdk.reportChatThreads(
            params,
            function onSuccess(result) {
              console.log("reportChatThreads", result);
              resolve(result);
            },
            function onError(result) {
              console.log(result);
              reject("Lỗi lấy thông tin cuộc chat hiện tại!");
            }
          );
        });

        if (ringmeChatReport?.open > 0) {
          enqueueSnackbar(
            `Không thể thay đổi trạng thái do có cuộc chat đang hỗ trợ!`,
            {
              variant: "error",
            }
          );
          return;
        }
      }

      await changeAgentChatStatusApi(newStatus);
      enqueueSnackbar("Thay đổi trạng thái thành công!", {
        variant: "success",
      });
      dispatch(setAgentChatStatus(newStatus)); // trạng thái là service -> gọi lại hàm ringme.init trong useEffect bên ngoài, nếu khác service -> logout tại đây
      dispatch(getStatusAgent());
      if (newStatus !== "service" && ringmeOttSdk?.logout)
        ringmeOttSdk.logout();
    } catch (error) {
      enqueueSnackbar(
        `Thay đổi trạng thái thất bại! ${error.message || error}`,
        {
          variant: "error",
        }
      );
    }
    setLoadingChangeAgentChatStatus(false);
  };

  const updateChatReport = useCallback(() => {
    dispatch(getAgentChatStatistic());

    const params = {
      startedAt: moment().startOf("day").valueOf(),
      endedAt: moment().valueOf(),
    };
    console.log("params reportChatThreads", params);

    ringmeOttSdk.reportChatThreads(
      params,
      function onSuccess(result) {
        console.log("reportChatThreads", result);
        setChatReport(result);
      },
      function onError(result) {
        console.log(result);
      }
    );
  }, [dispatch, ringmeOttSdk]);

  useEffect(() => {
    if (ringmeOttSdk && isAuthenticatedSdk) {
      setTimeout(() => {
        updateChatReport();
      }, 2000);

      const chatReportInterval = setInterval(() => {
        updateChatReport();
      }, 30 * 1000);

      return () => {
        clearInterval(chatReportInterval);
      };
    }
  }, [ringmeOttSdk, isAuthenticatedSdk, dispatch, updateChatReport]);

  const agentStatusChatId = agentStatus?.statusChatId;

  useEffect(() => {
    if (agentStatusChatId) {
      dispatch(setAgentChatStatus(agentStatusChatId));
    }
  }, [agentStatusChatId, dispatch]);

  return (
    <div className={`${classes.chatHeader__wrapper}`}>
      <div className={classes.chatHeader__agentInfo}>
        <img
          className={classes.chatHeader__avatar}
          alt=""
          src={AvatarUserDefaultIcon}
        />
        <div>
          <div className={classes.label} style={{ fontWeight: 500 }}>
            {user?.profile?.user?.fullname}
          </div>
          <div className={classes.label} style={{ fontWeight: 500 }}>
            {user?.profile?.user?.phoneNumber}
          </div>
        </div>

        <div>
          <div className={`${classes.label}`}>Trạng thái làm việc</div>

          <TextField
            variant="outlined"
            select
            fullWidth
            value={agentChatStatus}
            onChange={handleChangeAgentChatStatus}
            style={{ width: 135 }}
            InputProps={{
              classes: {
                input: classes.input,
              },
            }}
            disabled={
              (agentChatStatus === "service" && !chatReport) ||
              loadingChangeAgentChatStatus
            }>
            <MenuItem value={"service"} classes={{ root: classes.input }}>
              Sẵn sàng
            </MenuItem>
            <MenuItem value={"pause"} classes={{ root: classes.input }}>
              Tạm nghỉ
            </MenuItem>
            <MenuItem value={"eating"} classes={{ root: classes.input }}>
              Ăn ca
            </MenuItem>
            <MenuItem value={"busy"} classes={{ root: classes.input }}>
              Bận
            </MenuItem>
          </TextField>
          <PopupAddNewChat />
        </div>
      </div>

      <div style={{ flex: 1 }}>
        <Row style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.12)" }}>
          <Col
            xs={{ span: 6 }}
            style={{ borderRight: "1px solid rgba(0, 0, 0, 0.12)" }}>
            <div className={classes.titleHeader}>Agent</div>
          </Col>
          <Col xs={{ span: 4 }} offset={2}>
            <div className={classes.flexAlignCenter}>
              <Tooltip title="Tổng số cuộc đã chat">
                <span className={classes.icon}>
                  <i
                    className="fas fa-comment-dots"
                    style={{ color: "#015290" }}></i>
                </span>
              </Tooltip>
              <span className={classes.title}>{chatReport?.close || 0}</span>
            </div>
          </Col>
          <Col xs={{ span: 5 }}>
            <div className={classes.flexAlignCenter}>
              <Tooltip title="Tổng thời gian làm việc của agent">
                <span className={classes.icon}>
                  <i className="fas fa-clock" style={{ color: "#555555" }}></i>
                </span>
              </Tooltip>
              <span className={`${classes.title}`}>
                {agentChatStatistic?.totalTimeService
                  ? datetimeHelper.secondToHHMMSS(
                      agentChatStatistic.totalTimeService
                    )
                  : "00:00:00"}
              </span>
            </div>
          </Col>
          <Col xs={{ span: 5 }}>
            <div className={classes.flexAlignCenter}>
              <Tooltip title="Thời gian trung bình của các cuộc chat">
                <span className={classes.icon}>
                  <span>ACD</span>
                </span>
              </Tooltip>
              <span className={classes.title}>
                {chatReport?.timeAverage
                  ? datetimeHelper.secondToHHMMSS(chatReport.timeAverage / 1000)
                  : "00:00:00"}
              </span>
            </div>
          </Col>
        </Row>
        <Row>
          <Col
            xs={{ span: 6 }}
            style={{ borderRight: "1px solid rgba(0, 0, 0, 0.12)" }}>
            <div className={classes.titleHeader}>Contact Center</div>
          </Col>
          <Col xs={{ span: 4 }} offset={2}>
            <div className={classes.flexAlignCenter}>
              <Tooltip title="Tổng số cuộc chat của bộ phận">
                <span className={classes.icon}>
                  <i
                    className="fas fa-comment-dots"
                    style={{ color: "#1077A5" }}></i>
                </span>
              </Tooltip>
              <span className={`${classes.title}`}>
                {(agentChatStatistic?.doneThread || 0) +
                  (agentChatStatistic?.missingThread || 0)}
              </span>
            </div>
          </Col>
          <Col xs={{ span: 5 }}>
            <div className={classes.flexAlignCenter}>
              <Tooltip title={`Tỉ lệ trả lời`}>
                <span className={classes.icon}>
                  <i className="fas fa-clock" style={{ color: "#1077A5" }}></i>
                </span>
              </Tooltip>
              <span className={`${classes.title}`}>
                {`${
                  getPercentage(
                    agentChatStatistic?.doneThread,
                    agentChatStatistic?.doneThread +
                      agentChatStatistic?.missingThread
                  ) || 0
                } %`}
              </span>
            </div>
          </Col>
          <Col xs={{ span: 5 }}>
            <div className={classes.flexAlignCenter}>
              <Tooltip title="Bình quân thời gian chat của bộ phận">
                <span className={classes.icon}>
                  <span style={{ color: "#1077A5" }}>ACD</span>
                </span>
              </Tooltip>
              <span className={`${classes.title}`}>
                {agentChatStatistic?.departmentTimeDoneAvg
                  ? datetimeHelper.secondToHHMMSS(
                      agentChatStatistic.departmentTimeDoneAvg
                    )
                  : "00:00:00"}
              </span>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default AgentDashboardHeader;
